function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("radialGradient", {
  id: "a",
  cx: "9.22%",
  cy: "1.156%",
  r: "104%",
  gradientTransform: "matrix(1 0 0 .83674 0 .002)"
}, React.createElement("stop", {
  stopColor: "#D1DAE8",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#1A6AA0",
  offset: 0.42
}), React.createElement("stop", {
  stopColor: "#025186",
  offset: 0.77
}), React.createElement("stop", {
  stopColor: "#1E3B6F",
  offset: 1
})), React.createElement("linearGradient", {
  id: "b",
  x1: "48.248%",
  x2: "51.862%",
  y1: "-5.989%",
  y2: "106.27%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.24
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.41
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.47
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.57
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.68
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.77
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.84
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.94
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "c",
  x1: "49.51%",
  x2: "51.129%",
  y1: "31.131%",
  y2: "93.446%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.38
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.47
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.57
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.62
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.72
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.79
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.84
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.94
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("radialGradient", {
  id: "d",
  cx: "2.433%",
  cy: "-42.319%",
  r: "132.59%",
  gradientTransform: "matrix(1 0 0 .65079 0 -.148)"
}, React.createElement("stop", {
  stopColor: "#346AB2",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#346AB2",
  offset: 0.51
}), React.createElement("stop", {
  stopColor: "#213E76",
  offset: 0.83
})), React.createElement("linearGradient", {
  id: "e",
  x1: "49.196%",
  x2: "49.623%",
  y1: "-26.357%",
  y2: "14.179%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.38
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.47
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.57
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.62
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.72
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.79
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.84
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.94
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "f",
  x1: "49.36%",
  x2: "49.786%",
  y1: "-10.814%",
  y2: "29.723%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.38
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.47
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.57
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.62
}), React.createElement("stop", {
  stopColor: "#AE732A",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.72
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.79
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.84
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.94
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "g",
  x1: "17.763%",
  x2: "66.578%",
  y1: "-12.241%",
  y2: "81.977%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.38
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.47
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.57
}), React.createElement("stop", {
  stopColor: "#E29A39",
  offset: 0.62
}), React.createElement("stop", {
  stopColor: "#D89628",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.72
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.79
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.84
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.94
}), React.createElement("stop", {
  stopColor: "#F9BE4A",
  offset: 1
})), React.createElement("radialGradient", {
  id: "h",
  cx: "2.212%",
  cy: "-12.081%",
  r: "95.715%",
  gradientTransform: "matrix(1 0 0 .98438 0 -.002)"
}, React.createElement("stop", {
  stopColor: "#4782C3",
  offset: 0.14
}), React.createElement("stop", {
  stopColor: "#427CBF",
  offset: 0.34
}), React.createElement("stop", {
  stopColor: "#346AB2",
  offset: 0.61
}), React.createElement("stop", {
  stopColor: "#3164A8",
  offset: 0.69
}), React.createElement("stop", {
  stopColor: "#28528D",
  offset: 0.82
}), React.createElement("stop", {
  stopColor: "#1A3761",
  offset: 0.98
}), React.createElement("stop", {
  stopColor: "#18335B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "i",
  x1: "-173.25%",
  x2: "241.7%",
  y1: "-213.04%",
  y2: "302%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "j",
  x1: "-123.26%",
  x2: "277.47%",
  y1: "-198.49%",
  y2: "376.25%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "k",
  x1: "-46.27%",
  x2: "239.95%",
  y1: "-133.94%",
  y2: "432.64%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "l",
  x1: "-66.654%",
  x2: "328.23%",
  y1: "-110.44%",
  y2: "536.52%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "m",
  x1: "-40.15%",
  x2: "373.58%",
  y1: "-68.77%",
  y2: "475.82%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "n",
  x1: "-39.58%",
  x2: "391.76%",
  y1: "-40.508%",
  y2: "391.39%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "o",
  x1: "-175.04%",
  x2: "135.55%",
  y1: "-352.71%",
  y2: "205.13%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "p",
  x1: "-132%",
  x2: "147.6%",
  y1: "-313.9%",
  y2: "245.53%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "q",
  x1: "-113.77%",
  x2: "166.4%",
  y1: "-277.23%",
  y2: "282.84%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "r",
  x1: "-99.06%",
  x2: "182.39%",
  y1: "-238.56%",
  y2: "324.34%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "s",
  x1: "-60.567%",
  x2: "194.39%",
  y1: "-193.83%",
  y2: "368.43%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "t",
  x1: "-49.371%",
  x2: "231.77%",
  y1: "-158.46%",
  y2: "400.64%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "u",
  x1: "-34.92%",
  x2: "216.12%",
  y1: "-113.62%",
  y2: "448.72%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "v",
  x1: "-21.287%",
  x2: "260.43%",
  y1: "-82.819%",
  y2: "480.08%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "w",
  x1: "-346.46%",
  x2: "390.57%",
  y1: "-693.2%",
  y2: "689.06%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "x",
  x1: "-319.38%",
  x2: "304.7%",
  y1: "-460.92%",
  y2: "421.06%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "y",
  x1: "-394.05%",
  x2: "300.58%",
  y1: "-620.18%",
  y2: "445.42%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "z",
  x1: "-289.58%",
  x2: "212.85%",
  y1: "-824.18%",
  y2: "471.58%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "A",
  x1: "-387.2%",
  x2: "236.51%",
  y1: "-828.85%",
  y2: "415.64%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "B",
  x1: "-170.06%",
  x2: "130.1%",
  y1: "-830.35%",
  y2: "370.55%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "C",
  x1: "-440.34%",
  x2: "198.21%",
  y1: "-829.64%",
  y2: "335.46%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "D",
  x1: "-382.11%",
  x2: "151.11%",
  y1: "-897.98%",
  y2: "309.47%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "E",
  x1: "-545.53%",
  x2: "178.84%",
  y1: "-887.51%",
  y2: "252.9%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "F",
  x1: "-533.62%",
  x2: "171.34%",
  y1: "-811.97%",
  y2: "222.81%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "G",
  x1: "-702.97%",
  x2: "184.93%",
  y1: "-999.83%",
  y2: "209.76%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "H",
  x1: "-670.37%",
  x2: "188.14%",
  y1: "-821.39%",
  y2: "227.79%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "I",
  x1: "-697.2%",
  x2: "198.72%",
  y1: "-705.42%",
  y2: "199.76%"
}, React.createElement("stop", {
  stopColor: "#FFEEC3",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#F6ECA3",
  offset: 0.18
}), React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.29
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "J",
  x1: "-13.451%",
  x2: "126.98%",
  y1: "29.242%",
  y2: "86.569%"
}, React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.17
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})), React.createElement("linearGradient", {
  id: "K",
  x1: "-36.081%",
  x2: "104.82%",
  y1: "10.068%",
  y2: "67.089%"
}, React.createElement("stop", {
  stopColor: "#F3D070",
  offset: 0.17
}), React.createElement("stop", {
  stopColor: "#F8F3A6",
  offset: 0.4
}), React.createElement("stop", {
  stopColor: "#EDC55C",
  offset: 0.43
}), React.createElement("stop", {
  stopColor: "#E3B54E",
  offset: 0.53
}), React.createElement("stop", {
  stopColor: "#F1D76F",
  offset: 0.6
}), React.createElement("stop", {
  stopColor: "#F6E57E",
  offset: 0.65
}), React.createElement("stop", {
  stopColor: "#E4AE25",
  offset: 0.81
}), React.createElement("stop", {
  stopColor: "#E5B32A",
  offset: 0.89
}), React.createElement("stop", {
  stopColor: "#FFF1C6",
  offset: 0.95
}), React.createElement("stop", {
  stopColor: "#FBCB4B",
  offset: 1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  d: "M18 55v49l20.506-15.422L59 104V55z"
}), React.createElement("path", {
  fill: "url(#b)",
  fillRule: "nonzero",
  d: "M57 103l-.006-47H55l.012 45.54"
}), React.createElement("path", {
  fill: "url(#c)",
  fillRule: "nonzero",
  d: "M23 101.5V37h-1.994L21 103"
}), React.createElement("path", {
  fill: "url(#d)",
  fillRule: "nonzero",
  d: "M18 0h41v63H18z"
}), React.createElement("path", {
  fill: "url(#e)",
  fillRule: "nonzero",
  d: "M57 66V0h-2v66"
}), React.createElement("path", {
  fill: "url(#f)",
  fillRule: "nonzero",
  d: "M23 66V0h-2v66"
}), React.createElement("path", {
  fill: "#1E4281",
  fillRule: "nonzero",
  d: "M66.57 74.875l-6.033-1.289.119 6.01-5.659-2.41-1.085 5.924-5.066-3.444-2.248 5.606-4.276-4.341L38.988 86l-3.327-5.069-4.277 4.335-2.254-5.6-5.066 3.438-1.085-5.923-5.659 2.41.131-6.017-6.039 1.289 1.329-5.878-6.175.116 2.474-5.508-6.074-1.058 3.53-4.935-5.749-2.197 4.455-4.166L0 47.988l5.202-3.242-4.455-4.167 5.754-2.19-3.53-4.942 6.08-1.052-2.473-5.513 6.175.121-1.323-5.878 6.033 1.295-.125-6.016 5.659 2.41 1.085-5.924 5.066 3.444 2.254-5.606 4.276 4.341L39.012 10l3.327 5.069 4.277-4.335 2.248 5.606 5.066-3.444 1.085 5.923 5.659-2.41-.125 6.017 6.033-1.289-1.323 5.878 6.169-.122-2.474 5.514 6.08 1.058-3.535 4.941 5.754 2.191-4.455 4.166L78 48.012l-5.208 3.236 4.455 4.173-5.754 2.19 3.529 4.942-6.079 1.052 2.479 5.513-6.181-.121z"
}), React.createElement("path", {
  fill: "url(#g)",
  fillRule: "nonzero",
  d: "M65.717 74.875l-5.951-1.292.118 6.013-5.586-2.41-1.073 5.921-5.002-3.441-2.224 5.606-4.217-4.343L38.491 86l-3.285-5.071-4.223 4.337-2.224-5.606-5.001 3.441-1.068-5.921-5.585 2.411.123-6.02-5.957 1.287 1.31-5.874-6.093.116 2.442-5.507-5.999-1.065 3.486-4.931-5.674-2.195 4.394-4.168L0 47.985l5.143-3.236-4.4-4.174 5.68-2.189-3.486-4.937 6.005-1.059-2.448-5.513 6.098.122-1.303-5.874 5.951 1.292-.118-6.019 5.58 2.41 1.073-5.921 5.002 3.447 2.224-5.606 4.223 4.337L38.515 10l3.279 5.071 4.229-4.337 2.218 5.6 5.001-3.441 1.068 5.927 5.585-2.411-.118 6.014 5.958-1.286-1.31 5.873 6.093-.116-2.448 5.507 6.005 1.06-3.486 4.942 5.674 2.189-4.394 4.168L77 48.009l-5.137 3.242 4.394 4.169-5.674 2.188 3.486 4.937-6.005 1.06 2.442 5.507-6.098-.117z"
}), React.createElement("path", {
  d: "M39.488 16C22.092 16.007 7.994 30.337 8 48.01 8.005 65.682 22.112 80.005 39.508 80 56.904 79.996 71.003 65.666 71 47.994 70.987 30.323 56.884 16.003 39.488 16z",
  fill: "url(#h)",
  fillRule: "nonzero",
  stroke: "#F6E57E",
  strokeWidth: 0.5
}), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "url(#i)",
  d: "M43.651 15.619l-3.157 2.126-1.048-1.435 3.156-2.125 2.922-5.272 1.145 1.568-2.091 3.454 4.097-.731 1.144 1.568z",
  transform: "translate(15 19)"
}), React.createElement("path", {
  fill: "url(#j)",
  d: "M33.584 11.172l5.687-7.183 4.928 3.6-.994 1.248-3.446-2.531-1.331 1.684 2.945 2.16-1.012 1.248-2.951-2.154-1.38 1.742 3.464 2.531-.994 1.249z",
  transform: "translate(15 19)"
}), React.createElement("path", {
  fill: "url(#k)",
  d: "M26.994 9.017l2.512-8.71 1.771.471-2.078 7.194 4.108 1.098-.44 1.515z",
  transform: "translate(15 19)"
}), React.createElement("path", {
  fill: "url(#l)",
  d: "M19.88 9.22L19.036.239l1.807-.163.699 7.427 4.217-.372.151 1.568z",
  transform: "translate(15 19)"
}), React.createElement("path", {
  fill: "url(#m)",
  d: "M13.042 11.88L9.127 3.675l5.626-2.473.687 1.428-3.964 1.742.922 1.922 3.367-1.48.687 1.428-3.374 1.48.952 1.992 3.958-1.742.687 1.429z",
  transform: "translate(15 19)"
}), React.createElement("path", {
  fill: "url(#n)",
  d: "M10.898 13.819l-4.82-.981.283 1.794 2.115 1.8L7.27 17.75.24 11.775l1.205-1.318 3.06 2.602-.855-4.988 1.476-1.603.734 4.646 6.452 1.196z",
  transform: "translate(15 19)"
})), React.createElement("text", {
  fill: "#000",
  fontFamily: "OpenSans-Regular, Open Sans",
  fontSize: 9,
  letterSpacing: 0.225
}, React.createElement("tspan", {
  x: 61,
  y: 103
}, "\xAE")), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  fill: "url(#o)",
  d: "M56.831 9.789l-2.205-4.345-1.109 1.478V9.79h-1.669V.25h1.675v4.156L56.545.25h2.038L55.74 4.039l3.045 5.75z",
  transform: "translate(10 43)"
}), React.createElement("path", {
  d: "M49.888 8.822c-.566.653-1.418 1.033-2.318 1.033-.9 0-1.753-.38-2.319-1.033-.864-.966-.84-2.155-.84-3.822s0-2.839.84-3.8C45.811.537 46.665.15 47.57.15c.904 0 1.759.387 2.318 1.05.87.961.858 2.156.858 3.8s.012 2.856-.858 3.822zm-1.24-6.483a1.337 1.337 0 0 0-1.072-.511 1.369 1.369 0 0 0-1.085.51c-.322.4-.405.845-.405 2.679 0 1.833.083 2.277.405 2.677.251.325.656.515 1.085.512.426.004.827-.187 1.072-.511.328-.4.424-.84.424-2.678s-.096-2.278-.424-2.678z",
  fill: "url(#p)",
  transform: "translate(10 43)"
}), React.createElement("path", {
  d: "M42.748 8.822c-.566.655-1.42 1.036-2.321 1.036s-1.756-.38-2.322-1.036c-.864-.966-.84-2.155-.84-3.822s0-2.839.84-3.8c.566-.655 1.42-1.036 2.322-1.036s1.755.381 2.321 1.036c.864.961.852 2.156.852 3.8s.012 2.856-.852 3.822zM41.502 2.34a1.337 1.337 0 0 0-1.066-.511 1.363 1.363 0 0 0-1.085.51c-.328.4-.411.845-.411 2.679 0 1.833.083 2.277.411 2.677.25.326.655.517 1.085.512.424.004.823-.188 1.066-.511.328-.4.424-.84.424-2.678s-.096-2.278-.424-2.678z",
  fill: "url(#q)",
  transform: "translate(10 43)"
}), React.createElement("path", {
  d: "M33.833 9.789h-3.576V.25h3.445c1.669 0 2.646 1.044 2.646 2.678.035.784-.366 1.53-1.06 1.972.806.439 1.27 1.271 1.191 2.139-.024 1.783-1.12 2.75-2.646 2.75zm-.28-7.878h-1.639v2.222h1.639c.658 0 1.192-.497 1.192-1.11S34.21 1.91 33.553 1.91zM33.66 5.8h-1.746v2.344h1.746c.325.003.635-.126.85-.353a.998.998 0 0 0 .27-.83.981.981 0 0 0-.265-.832 1.141 1.141 0 0 0-.855-.346V5.8z",
  fill: "url(#r)",
  transform: "translate(10 43)"
}), React.createElement("path", {
  fill: "url(#s)",
  d: "M21.389 9.789V.25h5.65v1.667h-3.975v2.222h3.385v1.667h-3.385v2.316h3.975V9.79z",
  transform: "translate(10 43)"
}), React.createElement("path", {
  d: "M16.979 9.867c-1.788 0-3.159-1.328-3.159-3.334V.25h1.675v6.2c0 1.111.596 1.756 1.484 1.756s1.496-.656 1.496-1.756V.25h1.662v6.267c0 2.022-1.4 3.35-3.158 3.35z",
  fill: "url(#t)",
  transform: "translate(10 43)"
}), React.createElement("path", {
  fill: "url(#u)",
  d: "M7.79 9.789V.25h1.674v7.878h3.891v1.666z",
  transform: "translate(10 43)"
}), React.createElement("path", {
  d: "M4.07 9.789H.495V.25h3.444c1.675 0 2.652 1.044 2.652 2.678.036.784-.365 1.53-1.06 1.972.806.439 1.27 1.271 1.191 2.139-.03 1.783-1.126 2.75-2.652 2.75zM3.79 1.91H2.151v2.222h1.64c.658 0 1.191-.497 1.191-1.11S4.45 1.91 3.79 1.91zm.108 3.89H2.15v2.344h1.747a1.16 1.16 0 0 0 .847-.355c.215-.226.314-.528.273-.828a.987.987 0 0 0-.268-.83 1.147 1.147 0 0 0-.852-.348V5.8z",
  fill: "url(#v)",
  transform: "translate(10 43)"
})), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M2.044 5.4A1.826 1.826 0 0 1 .78 4.548a2.016 2.016 0 0 1-.32-1.542c.146-.768.693-1.152 1.444-1.698S3.191.36 3.924.492c.52.085.98.395 1.264.852.309.446.423 1.005.315 1.542-.146.768-.688 1.158-1.439 1.698s-1.292.93-2.02.816zM4.57 2.622a.953.953 0 0 0-.134-.726.837.837 0 0 0-.582-.39c-.291-.036-.524.066-1.357.672-.833.606-1.007.792-1.077 1.098a.929.929 0 0 0 .134.726c.13.21.343.35.582.384.291.036.524-.06 1.363-.666s.995-.816 1.07-1.116v.018z",
  fill: "url(#w)",
  transform: "translate(16 56)"
}), React.createElement("path", {
  fill: "url(#x)",
  d: "M6.545 5.004l-.938.942 1.398 1.542-.664.666L4.944 6.6l-1.55 1.56-.692-.762L6.516 3.6l2.329 2.568-.664.666z",
  transform: "translate(16 56)"
}), React.createElement("path", {
  fill: "url(#y)",
  d: "M9.683 8.076l-.768 1.098 1.636 1.254-.542.78-1.636-1.254-1.263 1.8-.81-.6 3.115-4.482 2.726 2.094-.542.78z",
  transform: "translate(16 56)"
}), React.createElement("path", {
  fill: "url(#z)",
  d: "M10.359 13.974l2.451-4.932.891.486-2.422 4.926z",
  transform: "translate(16 56)"
}), React.createElement("path", {
  d: "M14.109 15.738a1.923 1.923 0 0 1-1.106-1.074c-.303-.714-.059-1.362.25-2.262s.524-1.554 1.194-1.896a1.881 1.881 0 0 1 2.04.25 2.02 2.02 0 0 1 .662 2.006l-.955-.366a.904.904 0 0 0-.583-1.05.805.805 0 0 0-.698.036c-.262.156-.402.384-.752 1.386-.349 1.002-.378 1.272-.273 1.56a.87.87 0 0 0 .766.56.864.864 0 0 0 .812-.488l.955.372c-.4.902-1.415 1.326-2.312.966z",
  fill: "url(#A)",
  transform: "translate(16 56)"
}), React.createElement("path", {
  fill: "url(#B)",
  d: "M17.067 16.674l1.083-5.43.978.216-1.077 5.43z",
  transform: "translate(16 56)"
}), React.createElement("path", {
  d: "M22.127 17.4l-.227-1.008-1.817-.15-.384.948-1.066-.084 2.283-5.4.786.066 1.444 5.688-1.019-.06zm-.89-3.996l-.804 1.956 1.269.108-.466-2.064z",
  fill: "url(#C)",
  transform: "translate(16 56)"
}), React.createElement("path", {
  fill: "url(#D)",
  d: "M23.827 17.4l-.303-5.532 1.002-.06.25 4.566 2.329-.138.052.96z",
  transform: "translate(16 56)"
}), React.createElement("path", {
  d: "M32.293 15a1.91 1.91 0 0 1-1.165 1.116 1.813 1.813 0 0 1-1.502-.078c-.67-.342-.88-1.002-1.165-1.902-.285-.9-.547-1.548-.244-2.262.304-.703.974-1.163 1.72-1.181s1.438.409 1.774 1.097l-.95.36a.857.857 0 0 0-1.13-.432.839.839 0 0 0-.506.504c-.11.294-.075.552.274 1.554s.477 1.236.734 1.386c.215.12.47.135.698.042a.948.948 0 0 0 .583-.546 1.16 1.16 0 0 0 0-.78l-.07-.198-.885.336-.291-.852 1.816-.69.262.762c.247.557.264 1.194.047 1.764z",
  fill: "url(#E)",
  transform: "translate(16 56)"
}), React.createElement("path", {
  d: "M35.845 14.016a1.743 1.743 0 0 1-1.433.216 1.801 1.801 0 0 1-1.117-.948l-1.689-3.186.873-.51 1.672 3.15c.09.245.282.436.523.52.24.085.506.055.723-.082a.92.92 0 0 0 .45-.603.947.947 0 0 0-.142-.747l-1.67-3.15.873-.51 1.682 3.186c.259.452.325.993.184 1.497s-.477.926-.929 1.167z",
  fill: "url(#F)",
  transform: "translate(16 56)"
}), React.createElement("path", {
  fill: "url(#G)",
  d: "M38.832 12.036l-3.313-4.302.78-.666 3.296 4.332z",
  transform: "translate(16 56)"
}), React.createElement("path", {
  d: "M42.565 7.8a1.954 1.954 0 0 1-.582 1.374l-1.322 1.368L36.929 6.6l1.315-1.368a1.78 1.78 0 0 1 1.316-.6c.827 0 1.299.6 1.858 1.2.559.6 1.141 1.122 1.147 1.968zm-2.97-2.1a.855.855 0 0 0-.757.312l-.541.558 2.422 2.568.536-.558c.22-.2.333-.497.303-.798-.035-.312-.28-.6-.839-1.2-.559-.6-.832-.846-1.124-.882z",
  fill: "url(#H)",
  transform: "translate(16 56)"
}), React.createElement("path", {
  fill: "url(#I)",
  d: "M44.009 6.672L39.595 3.6 41.464.642l.763.534-1.316 2.082 1.031.72 1.123-1.77.763.534-1.118 1.8 1.066.75 1.316-2.082.762.534z",
  transform: "translate(16 56)"
})), React.createElement("g", {
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M15.256 1.13c6.189-.006 11.788 3.739 14.242 9.525h.96C27.95 4.348 21.938.22 15.256.22S2.56 4.348.054 10.655h.954C3.463 4.867 9.065 1.122 15.256 1.13z",
  fill: "url(#J)",
  transform: "translate(24 31)"
}), React.createElement("path", {
  d: "M15.256 32.786c-6.141.005-11.706-3.684-14.188-9.405h-.96c2.539 6.241 8.519 10.31 15.151 10.31s12.612-4.07 15.151-10.31h-.96c-2.49 5.717-8.053 9.403-14.194 9.405z",
  fill: "url(#K)",
  transform: "translate(24 31)"
})));

var SvgKbbLogoSeal = function SvgKbbLogoSeal(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 78 104",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgKbbLogoSeal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/KBBLogoSeal.0335f399.svg";
export { ForwardRef as ReactComponent };